<div class="accordion-container">
  <mat-accordion>
    <!-- First Panel: Password Form -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Generate Password</mat-panel-title>
      </mat-expansion-panel-header>
      <login-generate-password-form></login-generate-password-form>
    </mat-expansion-panel>

    <!-- Second Panel: New User Form -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>New User</mat-panel-title>
      </mat-expansion-panel-header>
      <login-new-user-form></login-new-user-form>
    </mat-expansion-panel>

    <!-- Third Panel: Permissions -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>User Permissions</mat-panel-title>
      </mat-expansion-panel-header>
      <login-permissions></login-permissions>
    </mat-expansion-panel>
  </mat-accordion>
</div>
